/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PersonHandleType = {
    EmailAddress: 'email_address',
    PhoneNumber: 'phone_number',
    Username: 'username'
} as const;
export type PersonHandleType = typeof PersonHandleType[keyof typeof PersonHandleType];


export function instanceOfPersonHandleType(value: any): boolean {
    for (const key in PersonHandleType) {
        if (Object.prototype.hasOwnProperty.call(PersonHandleType, key)) {
            if (PersonHandleType[key as keyof typeof PersonHandleType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PersonHandleTypeFromJSON(json: any): PersonHandleType {
    return PersonHandleTypeFromJSONTyped(json, false);
}

export function PersonHandleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonHandleType {
    return json as PersonHandleType;
}

export function PersonHandleTypeToJSON(value?: PersonHandleType | null): any {
    return value as any;
}

export function PersonHandleTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PersonHandleType {
    return value as PersonHandleType;
}

